'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.underscoredToCamelCase = underscoredToCamelCase;
exports.eventName = eventName;
exports.generateReduxNamespace = generateReduxNamespace;
exports.generateReduxEventName = generateReduxEventName;
exports.isAutogeneratedReduxEventName = isAutogeneratedReduxEventName;
exports.checkForAutogeneratedEventNameCollision = checkForAutogeneratedEventNameCollision;
// Converts `UNDERSCORED_NAMES` to `camelCasedNames`.
// E.g. event `GET_USERS_ERROR` => state.`getUsersError`.
function underscoredToCamelCase(string) {
	return string.split('_').map(function (word, i) {
		var firstLetter = word.slice(0, 1);
		var rest = word.slice(1);

		if (i === 0) {
			firstLetter = firstLetter.toLowerCase();
		} else {
			firstLetter = firstLetter.toUpperCase();
		}

		return firstLetter + rest.toLowerCase();
	}).join('');
}

// Converts `namespace` and `event` into a namespaced event name
function eventName(namespace, event) {
	return namespace ? namespace + ': ' + event : event;
}

var DEFAULT_REDUX_EVENT_NAMING = exports.DEFAULT_REDUX_EVENT_NAMING = function DEFAULT_REDUX_EVENT_NAMING(event) {
	return [event + '_PENDING', event + '_SUCCESS', event + '_ERROR'];
};

function generateReduxNamespace(counter) {
	return 'REACT_WEBSITE_' + counter;
}

function generateReduxEventName(counter) {
	return 'REACT_WEBSITE_ACTION_' + counter;
}

function isAutogeneratedReduxEventName(name) {
	// Matches "REACT_WEBSITE_1: REACT_WEBSITE_ACTION_2_PENDING".
	// Matches "REACT_WEBSITE_1: REACT_WEBSITE_ACTION_2".
	// Matches "SLIDESHOW: REACT_WEBSITE_ACTION_3".
	// Matches "SLIDESHOW: REACT_WEBSITE_ACTION_3_ENDING".
	return name.indexOf('REACT_WEBSITE_') >= 0;
}

// Checks for `ReduxModule` autogenerated event names conflicts.
function checkForAutogeneratedEventNameCollision(reducers) {
	var reduxModuleAutogeneratedEventNames = {};
	for (var _iterator = Object.keys(reducers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var reducerName = _ref;

		if (reducers[reducerName]._react_website_events) {
			var autogeneratedReduxEventNames = [];
			for (var _iterator2 = reducers[reducerName]._react_website_events, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
				var _ref2;

				if (_isArray2) {
					if (_i2 >= _iterator2.length) break;
					_ref2 = _iterator2[_i2++];
				} else {
					_i2 = _iterator2.next();
					if (_i2.done) break;
					_ref2 = _i2.value;
				}

				var _eventName = _ref2;

				if (isAutogeneratedReduxEventName(_eventName)) {
					for (var _iterator3 = Object.keys(reduxModuleAutogeneratedEventNames), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
						var _ref3;

						if (_isArray3) {
							if (_i3 >= _iterator3.length) break;
							_ref3 = _iterator3[_i3++];
						} else {
							_i3 = _iterator3.next();
							if (_i3.done) break;
							_ref3 = _i3.value;
						}

						var _reducerName = _ref3;

						if (reduxModuleAutogeneratedEventNames[_reducerName].indexOf(_eventName) >= 0) {
							throw new Error('"ReduxModule" autogenerated action "type" collision detected for reducers "' + _reducerName + '" and "' + reducerName + '" and action "type" "' + _eventName + '". Specify an explicit namespace for any of the two reducers to resolve the conflict.');
						}
					}
					autogeneratedReduxEventNames.push(_eventName);
				}
			}
			reduxModuleAutogeneratedEventNames[reducerName] = autogeneratedReduxEventNames;
		}
	}
}
//# sourceMappingURL=naming.js.map